import * as z from "zod";

/**
 * The deployment history for a single extension target — every artifact that
 * has been live for it, newest first, with who deployed it and when.
 *
 * The target is addressed in friendly terms (rate table id, or flow + step id);
 * the handler derives the underlying natural key via the deployment-target
 * helpers so callers don't have to know the key format.
 */
export const getTargetDeployments = {
  name: "getTargetDeployments" as const,
  input: z.union([
    z.object({
      targetType: z.literal("checkout.shipping-method.custom-rate-table"),
      rateTableId: z.string(),
    }),
    z.object({
      targetType: z.literal("oms-automation.code-step"),
      flowId: z.string(),
      stepId: z.string(),
    }),
  ]),
  output: z.object({
    deployments: z.array(
      z.object({
        artifactId: z.string(),
        actor: z
          .union([
            z.object({ type: z.literal("userId"), userId: z.string() }),
            z.object({ type: z.literal("admin"), email: z.string() }),
            z.object({ type: z.literal("agent"), agentId: z.string() }),
          ])
          .nullable(),
        deployedAt: z.string(),
      }),
    ),
  }),
};
